var map = {
	"./": 322,
	"./Results.dictionaty": 347,
	"./Results.dictionaty.json": 347,
	"./Results.explanation": 1171,
	"./Results.explanation.ts": 1171,
	"./Results.module.scss": 1172,
	"./ResultsPage": 1173,
	"./ResultsPage.tsx": 1173,
	"./ResultsPageDeferred": 380,
	"./ResultsPageDeferred.tsx": 380,
	"./actions": 334,
	"./actions.ts": 334,
	"./components/Filters": 1030,
	"./components/Filters/": 1030,
	"./components/Filters/ButtonBar": 953,
	"./components/Filters/ButtonBar/": 953,
	"./components/Filters/ButtonBar/ButtonBar.module.scss": 1069,
	"./components/Filters/ButtonBar/index": 953,
	"./components/Filters/ButtonBar/index.tsx": 953,
	"./components/Filters/DatePick": 1008,
	"./components/Filters/DatePick/": 1008,
	"./components/Filters/DatePick/DatePick.module.scss": 1094,
	"./components/Filters/DatePick/index": 1008,
	"./components/Filters/DatePick/index.tsx": 1008,
	"./components/Filters/DatePick/types": 1175,
	"./components/Filters/DatePick/types.ts": 1175,
	"./components/Filters/Filter.module.scss": 1174,
	"./components/Filters/Filters.dictionary": 1098,
	"./components/Filters/Filters.dictionary.json": 1098,
	"./components/Filters/Search": 1009,
	"./components/Filters/Search/": 1009,
	"./components/Filters/Search/Search.dictionary": 1066,
	"./components/Filters/Search/Search.dictionary.json": 1066,
	"./components/Filters/Search/Search.module.scss": 1095,
	"./components/Filters/Search/index": 1009,
	"./components/Filters/Search/index.tsx": 1009,
	"./components/Filters/Sorts": 1010,
	"./components/Filters/Sorts/": 1010,
	"./components/Filters/Sorts/Sorts.dictionary": 1067,
	"./components/Filters/Sorts/Sorts.dictionary.json": 1067,
	"./components/Filters/Sorts/Sorts.module.scss": 1096,
	"./components/Filters/Sorts/index": 1010,
	"./components/Filters/Sorts/index.tsx": 1010,
	"./components/Filters/SportsList": 1011,
	"./components/Filters/SportsList/": 1011,
	"./components/Filters/SportsList/SportsList.module.scss": 1097,
	"./components/Filters/SportsList/index": 1011,
	"./components/Filters/SportsList/index.tsx": 1011,
	"./components/Filters/index": 1030,
	"./components/Filters/index.tsx": 1030,
	"./components/Tables": 1013,
	"./components/Tables/": 1013,
	"./components/Tables/Table": 954,
	"./components/Tables/Table/": 954,
	"./components/Tables/Table/Header": 919,
	"./components/Tables/Table/Header/": 919,
	"./components/Tables/Table/Header/Header.dictionary": 955,
	"./components/Tables/Table/Header/Header.dictionary.json": 955,
	"./components/Tables/Table/Header/Header.module.scss": 1014,
	"./components/Tables/Table/Header/index": 919,
	"./components/Tables/Table/Header/index.tsx": 919,
	"./components/Tables/Table/Match": 920,
	"./components/Tables/Table/Match/": 920,
	"./components/Tables/Table/Match/Match.module.scss": 1015,
	"./components/Tables/Table/Match/index": 920,
	"./components/Tables/Table/Match/index.tsx": 920,
	"./components/Tables/Table/Table.dictionary": 1016,
	"./components/Tables/Table/Table.dictionary.json": 1016,
	"./components/Tables/Table/Table.module.scss": 1070,
	"./components/Tables/Table/index": 954,
	"./components/Tables/Table/index.tsx": 954,
	"./components/Tables/Tables.dictionary": 1071,
	"./components/Tables/Tables.dictionary.json": 1071,
	"./components/Tables/Tables.module.scss": 1099,
	"./components/Tables/index": 1013,
	"./components/Tables/index.tsx": 1013,
	"./constants": 836,
	"./constants.ts": 836,
	"./index": 322,
	"./index.tsx": 322,
	"./reducer": 356,
	"./reducer.ts": 356,
	"./types": 1118,
	"./types.ts": 1118,
	"./utils/getScores": 956,
	"./utils/getScores.ts": 956,
	"./utils/sort": 1012,
	"./utils/sort.ts": 1012,
	"./utils/sportsList": 1068,
	"./utils/sportsList.ts": 1068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1287;
module.exports = webpackContext;